import { Row, Col, Typography, Space } from "antd";
import {
    TwitterOutlined, FacebookOutlined, InstagramOutlined, LinkedinOutlined
} from "@ant-design/icons";
import { Link } from "react-router-dom";
const { Title, Paragraph, Text } = Typography;

const Footer = () => {
    return (
        <>
            <footer id="footer" className="footer dark-background">
                <div className="container footer-top">
                    <Row gutter={[24, 24]}>

                        {/* About */}
                        <Col xs={24} lg={10}>
                            <Space orientation="vertical" size="middle">
                                <Title level={3} style={{ marginBottom: 0, color: '#fff' }}>
                                    GMR Enlaces
                                </Title>

                                <Paragraph className="text-white text-justify">
                                    Expertos en logística de transporte, ofreciendo soluciones flexibles y dinámicas que garantizan envíos eficientes tanto a nivel nacional como internacional. Nuestra experiencia y compromiso nos posicionan como una opción confiable para manejar tus necesidades de transporte y distribución.
                                </Paragraph>

                                <Space size="middle" className="social-links d-flex">
                                    <Link href="#"><TwitterOutlined /></Link>
                                    <Link href="#"><FacebookOutlined /></Link>
                                    <Link href="#"><InstagramOutlined /></Link>
                                    <Link href="#"><LinkedinOutlined /></Link>
                                </Space>
                            </Space>
                        </Col>

                        {/* Useful Links */}
                        <Col xs={12} md={6} lg={4}>
                            <Title level={5} className="text-white">Enlaces</Title>
                            <Space orientation="vertical">
                                <Link to="/">Home</Link>
                                <Link to="/gmr-enlaces/nosotros">Nosotros</Link>
                                <Link to="/gmr-enlaces/servicios">Servicios</Link>
                                <Link to="#">Terminos de servicio</Link>
                                <Link to="#">Politica de privacidad</Link>
                            </Space>
                        </Col>

                        {/* Contact */}
                        <Col xs={24} md={12} lg={5}>
                            <Title level={5} className="text-white">Ubicación</Title>
                            <Paragraph className="text-white mb-1">
                                Avenida Mariano Otero 3429, piso 1 - interior 3.
                            </Paragraph>
                            <Paragraph className="text-white mb-1">
                                Zapopan, Jalisco.
                            </Paragraph>
                            <Paragraph className="text-white mb-1">
                                C.P. 45080.
                            </Paragraph>
                        </Col>

                        <Col xs={12} md={6} lg={5}>
                            <Title level={5} className="text-white">Contacto</Title>
                            <Paragraph className="text-white mb-1">
                                <strong>Teléfonos:</strong>
                            </Paragraph>

                            <Paragraph className="text-white mb-1">
                                <ul>
                                    <li>+52 33 1992 1946 (Administración)</li>
                                    <li>+52 33 1322 6683 (Ventas)</li>
                                </ul>
                            </Paragraph>

                            <Paragraph className="text-white mb-1">
                                <strong>Correos:</strong>
                            </Paragraph>

                            <Paragraph className="text-white">
                                <ul>
                                    <li><Link href="mailto:operaciones@gmrlog.com">operaciones@gmrlog.com</Link></li>
                                    <li><Link href="mailto:trafico2@gmrlog.com">trafico2@gmrlog.com</Link></li>
                                </ul>
                            </Paragraph>
                        </Col>

                    </Row>
                </div>

                {/* Copyright */}
                <div className="container copyright text-center" style={{ marginTop: 40 }}>
                    <Text className="text-white">
                        © Copyright <strong style={{ margin: "0 6px" }}>GMR Enlaces</strong>
                    </Text>
                </div>
            </footer>
        </>
    )
}

export default Footer
